export const EfficiencyStyles = ({theme: {fonts, colors, icons}}) => {
  return {
    title: {
      ...fonts.BODY2,
      color: colors.NEUTRAL_HIGH,
    },
  };
};
